module.exports = __webpack_public_path__ + "cement/img/蒙版组 125.caf2be58.png";